module.exports = __webpack_public_path__ + "img/help24.45009a5a.png";